import React, { useCallback } from 'react'
import { Breadcrumbs, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useDispatch, useSelector } from 'react-redux'
import { skillBiteSlice } from '../../../reducers'
import { upperFirst } from 'lodash'
import { ActionButton } from '../../../components'

export const useStyles = makeStyles(({ breakpoints, palette, spacing, typography }) => ({
  root: {
    color: palette.grey[70],
    marginLeft: spacing(-1),
    '& .MuiButton-root': {
      color: palette.grey.shade[70],
      textTransform: 'capitalize',
      fontSize: typography.breadcrumb.fontSize
    }
  },
  active: {
    color: `${palette.primary.shade[70]} !important`,
    fontWeight: 600,
    textDecoration: 'underline'
  }
}))

export const SkillBiteBreadcrumbs = ({ isLoading }) => {
  const classes = useStyles()
  const session = useSelector(skillBiteSlice.selectors.selectSession)
  const currentSection = useSelector(skillBiteSlice.selectors.selectCurrentSection)
  const breadCrumbItems = isLoading ? new Array(5).fill({ name: Math.random() }) : session.sections.map(section => ({ name: section.name, id: section.id, order: section.order }))

  const dispatch = useDispatch()
  const handleChangeSection = useCallback((sectionId) => {
    dispatch(skillBiteSlice.actions.changeSection({ sectionId }))
  }, [dispatch])

  return (
    <Breadcrumbs
      data-test='breadcrumbs'
      classes={{ root: classes.root }}
      separator='>'
    >
      {breadCrumbItems.map((crumb, index) => {
        if (isLoading) {
          return <Skeleton key={index} width='4.5em' height='40px' />
        }

        const isActive = crumb.id === currentSection?.id

        return (
          <ActionButton
            key={index}
            label={upperFirst(crumb.name)}
            onClick={() => handleChangeSection(crumb.id)}
            data-test={`breadcrumbs-crumb-${crumb?.name}`}
            variant='link'
            data-is-active={isActive}
            className={isActive && classes.active}
          />
        )
      })}
    </Breadcrumbs>
  )
}
